import type { GlobalSearchResult, ModuleSearchAdapter } from "../types";
import { getSearchClient } from "../apiClient";

interface UserHit {
  id: string;
  name: string;
  email: string;
}

interface TeamHit {
  id: string;
  name: string;
  description?: string;
}

interface Response<T> {
  count: number;
  results: T[];
}

function mapUser(u: UserHit): GlobalSearchResult {
  return {
    id: `people:user:${u.id}`,
    moduleId: "people",
    title: u.name,
    subtitle: u.email,
    href: `/people/users/${encodeURIComponent(u.id)}`,
  };
}

function mapTeam(t: TeamHit): GlobalSearchResult {
  return {
    id: `people:team:${t.id}`,
    moduleId: "people",
    title: t.name,
    subtitle: t.description || undefined,
    href: `/people/teams/${encodeURIComponent(t.id)}`,
  };
}

export const peopleAdapter: ModuleSearchAdapter = {
  moduleId: "people",
  label: "People",
  async search(q, signal) {
    const qEncoded = encodeURIComponent(q);
    const [users, teams] = await Promise.all([
      getSearchClient().get<Response<UserHit>>(
        `/api/people/api/v1.0/users/search/?q=${qEncoded}&page_size=3`,
        { signal },
      ),
      getSearchClient().get<Response<TeamHit>>(
        `/api/people/api/v1.0/teams/search/?q=${qEncoded}&page_size=3`,
        { signal },
      ),
    ]);
    return [...users.results.map(mapUser), ...teams.results.map(mapTeam)];
  },
};
